var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6454 11.4078C16.078 11.7167 16.1217 12.3155 15.7383 12.6778L15.6589 12.7528C15.3501 13.0445 14.8633 13.0826 14.5079 12.8428L9.97184 9.13271L5.49206 12.8427C5.1367 13.0825 4.6499 13.0445 4.3411 12.7527L4.26168 12.6777C3.87825 12.3155 3.92205 11.7167 4.35458 11.4077L9.43303 7.17078C9.7518 6.94307 10.1919 6.94307 10.5106 7.17078L15.6454 11.4078Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrow_up_icon.49b7907edb8d42bd8193af0f7921f2a8.svg";
export { ForwardRef as ReactComponent };